import { MotionConfig } from "framer-motion";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyFaiz from "@/components/WhyFaiz";
import Process from "@/components/Process";
import FinalCta from "@/components/FinalCta";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Nav />
      <main>
        <Hero />
        <Story />
        <About />
        <Services />
        <WhyFaiz />
        <Process />
        <FinalCta />
        <Contact />
      </main>
      <Footer />
    </MotionConfig>
  );
}

export default App;
